import { IconDefinition } from '@fortawesome/fontawesome-common-types'

import Icon from 'src/components/widgets/Icon/Icon'

const ScrollButton = ({
  icon,
  onClick,
  top,
  ...props
}: {
  icon: IconDefinition
  left?: number
  right?: number
  top: number
  onClick: () => void
}) => (
  <Icon
    display="flex"
    justifyContent="center"
    alignItems="center"
    icon={icon}
    position="absolute"
    top={`calc(50% + ${top}px)`}
    {...props}
    onClick={onClick}
    borderWidth="1px"
    borderStyle="solid"
    borderColor="sandstone"
    borderRadius="full"
    fontSize={11}
    boxSize="32px"
    cursor="pointer"
  />
)

export default ScrollButton
